import { render, staticRenderFns } from "./custom-select.vue?vue&type=template&id=479dfb97&scoped=true&"
import script from "./custom-select.vue?vue&type=script&lang=js&"
export * from "./custom-select.vue?vue&type=script&lang=js&"
import style0 from "./custom-select.vue?vue&type=style&index=0&id=479dfb97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479dfb97",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/nuxt-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('479dfb97')) {
      api.createRecord('479dfb97', component.options)
    } else {
      api.reload('479dfb97', component.options)
    }
    module.hot.accept("./custom-select.vue?vue&type=template&id=479dfb97&scoped=true&", function () {
      api.rerender('479dfb97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/template/form/custom-select.vue"
export default component.exports